import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import myphoto2 from '../assets/images/image.png';
import myphoto from '../assets/images/myphoto.jpeg';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={myphoto2} 
            style={{
              width: '150px', // Adjust size as needed
              height: '150px',
              borderRadius: '50%',
              objectFit: 'cover',
              border: '2px solid #ccc', // Optional: Add a border
            }}
          alt="Avatar" />
          {/* <img src={myphoto} alt="Avatar" /> */}
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/saoud77" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/saoudalturki/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Saoud Alturki</h1>
          <p>Software Engineer</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/saoud77" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/saoudalturki/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;